import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./level2FilterOption.html";
import { i18nStore } from '../../../modules/stores/i18nStore';
const OPENED_TOGGLE_CLASS = 'toggle-section-icon opened';
const CLOSED_TOGGLE_CLASS = 'toggle-section-icon closed';
const OPENED_CONTENT_CLASS = 'section-content opened';
const CLOSED_CONTENT_CLASS = 'section-content closed';
export function isL2OptionEventDetail(detail) {
  return 'parentValue' in detail && !('childOptionChanged' in detail);
}
export function isL2OptionChangeEventDetail(detail) {
  return 'childOptionChanged' in detail;
}
class Level2FilterOption extends LightningElement {
  constructor(...args) {
    super(...args);
    this.multiple = void 0;
    this.selectedValue = void 0;
    this.opened = true;
    this._l2option = void 0;
  }
  set l2option(option) {
    const isChildSelected = option.childSelectedValues && option.childSelectedValues.length > 0;
    if (option.isL2Filter) {
      // @ts-expect-error * Automated Type Error Fix
      this.opened = isChildSelected || option.checked || option.toggleDefault;
    }
    this._l2option = option;
  }
  get l2option() {
    return this._l2option;
  }
  get toggleClass() {
    return this.opened ? OPENED_TOGGLE_CLASS : CLOSED_TOGGLE_CLASS;
  }
  get toggleLabel() {
    const filterLabels = i18nStore.getState().i18n.search.filters;
    if (this.opened) {
      return filterLabels.level2FilterCollapseAriaLabel({
        sectionLabel: this.l2option.label
      });
    }
    return filterLabels.level2FilterExpandAriaLabel({
      sectionLabel: this.l2option.label
    });
  }
  get isChildSelected() {
    return this._l2option.childSelectedValues && this._l2option.childSelectedValues.length > 0;
  }
  handleToggleSectionClick() {
    this.opened = !this.opened;
  }
  get contentClass() {
    return this.opened ? OPENED_CONTENT_CLASS : CLOSED_CONTENT_CLASS;
  }
  get inputType() {
    return this.multiple ? 'checkbox' : 'radio';
  }
  handleChildOptionChange(event) {
    event.stopPropagation();
    const element = event.target;
    // Re-Dispatch Event
    this.dispatchEvent(new CustomEvent('change', {
      detail: {
        childSelectedValues: element.value,
        parentChecked: false,
        childOptionChanged: true,
        parentValue: this.l2option.value
      },
      composed: true,
      bubbles: true,
      cancelable: true
    }));
  }
  handleParentSelection(event) {
    event.stopPropagation();
    const element = event.target;
    if (this.l2option.isL2Filter) {
      this.opened = element.checked;
    }
    this.dispatchEvent(new CustomEvent(event.type, {
      detail: {
        parentValue: element.value,
        parentChecked: element.checked
      },
      composed: true,
      bubbles: true,
      cancelable: true
    }));
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Level2FilterOption, {
  publicProps: {
    multiple: {
      config: 0
    },
    selectedValue: {
      config: 0
    },
    l2option: {
      config: 3
    }
  },
  track: {
    _l2option: 1
  },
  fields: ["opened"]
});
const __lwc_component_class_internal = _registerComponent(Level2FilterOption, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;